import { ErrorResponse, UserRequestDto } from "@gtpl/shared-models/common-models";
import { EmployeesDeptWiseCountDto, EmployeesDeptWiseResponseModel } from "@gtpl/shared-models/gtpl";
import { EmployeeWeekOffUploadsDto, HolidayCalenderModelDtoReq, HolidayDateReq, HolidaysCalendarDto, HolidaysResponseModel, ShiftCodeReq, TeamCalenderDto, TeamCalenderResponse } from "@gtpl/shared-models/hrms";
import { AllDepartmentsResponseModel, AllEmployeesResponseModel, AllUnitcodeResponseModel, CommonResponse, DepartmentDto, DeptRequest, EmployeeCodeRequest, EmployeeDto, EmployeeResponseModel, UnitcodeDto } from "@gtpl/shared-models/masters";
import { EmployeeWeekOffUploadsServices, HolidaysCalendarService, TeamCalenderService } from "@gtpl/shared-services/hrms";
import { DepartmentService, EmployeeService, UnitcodeService } from "@gtpl/shared-services/masters";
import { Injectable } from "@nestjs/common";
import { HolidaysCalendarDTO } from "../holidays-calender/dto/holidays-calendar.dto";

@Injectable()
export class AttendanceHelperService {
    constructor(
        private employeeService: EmployeeService,
        private departmentService: DepartmentService,
        private teamCalenderService: TeamCalenderService,
        private UnitCodeService: UnitcodeService,
        private holidayService : HolidaysCalendarService,
        private employeeWeekOff: EmployeeWeekOffUploadsServices
    ) {

    }

    async getAllActiveEmployees(): Promise<EmployeeDto[]> {
        const emps: AllEmployeesResponseModel = await this.employeeService.getAllActiveEmployees();
        if (!emps.status) {
            throw new ErrorResponse(emps.intlCode, emps.internalMessage);
        }
        return emps.data;
    }

    async getAllEmployees(): Promise<EmployeeDto[]> {
        const emps: AllEmployeesResponseModel = await this.employeeService.getAllEmployees();
        if (!emps.status) {
            throw new ErrorResponse(emps.intlCode, emps.internalMessage);
        }
        return emps.data;
    }

    async getAllDepartments(): Promise<DepartmentDto[]> {
        const departments: AllDepartmentsResponseModel = await this.departmentService.getAllDepartments();
        if (!departments.status) {
            throw new ErrorResponse(departments.intlCode, departments.internalMessage);
        }
        return departments.data;
    }

    async getAllUnitcodes(): Promise<UnitcodeDto[]> {
        const req = new UserRequestDto('')
        const unit: AllUnitcodeResponseModel = await this.UnitCodeService.getAllUnitcode(req);
        if (!unit.status) {
            throw new ErrorResponse(unit.intlCode, unit.internalMessage);
        }
        return unit.data;
    }

    async getActiveEmployeesByEmpCode(empCode: string): Promise<EmployeeDto> {
        const req = new EmployeeCodeRequest(empCode);
        const empInfo: EmployeeResponseModel = await this.employeeService.getActiveEmployeesByEmpCode(req);
        if (!empInfo.status) {
            throw new ErrorResponse(empInfo.intlCode, empInfo.internalMessage);
        }
        return empInfo.data;
    }

    async getEmployeeByEmpCode(empCode: string): Promise<EmployeeDto> {
        const req = new EmployeeCodeRequest(empCode);
        const empInfo: EmployeeResponseModel = await this.employeeService.getEmployeeByEmpCode(req);
        if (!empInfo.status) {
            throw new ErrorResponse(empInfo.intlCode, empInfo.internalMessage);
        }
        return empInfo.data;
    }

    async getEmployeeActiveInactive(empCode: string): Promise<EmployeeResponseModel> {
        const req = new EmployeeCodeRequest(empCode);
        const empInfo = await this.employeeService.getEmployeeByEmpCode(req);
        return empInfo;
    }

    async getActiveEmployeesByDeptId(deptId: number): Promise<EmployeeDto[]> {
        const empInfo: AllEmployeesResponseModel = await this.employeeService.getActiveEmployeesByDeptId(deptId);
        if (!empInfo.status) {
            throw new ErrorResponse(empInfo.intlCode, empInfo.internalMessage);
        }
        return empInfo.data;
    }

    async getActiveEmpDeptWiseCount(deptId: number): Promise<EmployeesDeptWiseCountDto> {
        const deptReq = new DeptRequest(deptId);
        const empInfo: EmployeesDeptWiseResponseModel = await this.employeeService.getActiveEmpDeptWiseCount(deptReq);
        if (!empInfo.status) {
            throw new ErrorResponse(empInfo.intlCode, empInfo.internalMessage);
        }
        return empInfo.data;
    }

    async getTeamCalenderRecords(shiftCode: string): Promise<TeamCalenderDto[]> {
        const req = new ShiftCodeReq(shiftCode);
        const records: TeamCalenderResponse = await this.teamCalenderService.getTeamCalenderRecords(req);
        if (!records.status) {
            throw new ErrorResponse(records.intlCode, records.internalMessage);
        }
        return records.data;
    }
    async getAllActiveHolidaysByNextDay(nextDay: string): Promise<HolidaysCalendarDto[]> {
        const req = new HolidayDateReq(nextDay);
        const records: CommonResponse = await this.holidayService.getAllActiveHolidaysByNextDay(req);
        if (!records.status) {
            throw new ErrorResponse(records.intlCode, records.internalMessage);
        }
        return records.data;
    }
    async getWeekOffByEmpCode(empCode: string): Promise<EmployeeWeekOffUploadsDto[]> {
        const req = new EmployeeCodeRequest(empCode);
        const records: CommonResponse = await this.employeeWeekOff.getWeekOffByEmpCode(req);
        if (!records.status) {
            throw new ErrorResponse(records.intlCode, records.internalMessage);
        }
        return records.data;
    }
    
}